import { useEffect } from "react"
import { Modal, Form, Input, Switch } from "antd"
import { RoleModalProps, RoleFormData, RoleStatus } from "../types"
import {
  RoleStatusLabels,
  ROLE_NAME_VALIDATION,
  ROLE_CODE_VALIDATION,
  ROLE_NOTE_VALIDATION,
} from "../constants"

const { TextArea } = Input

const RoleModal = ({
  isOpen,
  onClose,
  onSave,
  role,
  loading = false,
}: RoleModalProps) => {
  const [form] = Form.useForm<RoleFormData>()
  const isEditMode = !!role

  // 编辑模式：填充现有数据
  useEffect(() => {
    if (isOpen) {
      if (role) {
        form.setFieldsValue({
          name: role.name,
          code: role.code,
          note: role.note,
          status: role.status || RoleStatus.ACTIVE,
        })
      } else {
        form.resetFields()
      }
    }
  }, [isOpen, role, form])

  // 处理表单提交
  const handleSubmit = async () => {
    const values = await form.validateFields()
    const formData: RoleFormData = {
      name: values.name,
      code: values.code,
      note: values.note,
      status: values.status,
    }
    onSave(formData)
  }

  // 处理取消
  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title={role ? "编辑角色信息" : "新增角色"}
      open={isOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading}
      width={600}
      destroyOnHidden
      okText="确定"
      cancelText="取消"
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          name="name"
          label="角色名称"
          rules={[{ required: true, message: ROLE_NAME_VALIDATION.REQUIRED_MESSAGE }]}
        >
          <Input
            placeholder="请输入角色名称"
            maxLength={ROLE_NAME_VALIDATION.MAX_LENGTH}
          />
        </Form.Item>

        <Form.Item
          name="code"
          label="角色代码"
          rules={[{ required: true, message: ROLE_CODE_VALIDATION.REQUIRED_MESSAGE }]}
        >
          <Input
            placeholder="请输入角色代码（如：ADMIN）"
            maxLength={ROLE_CODE_VALIDATION.MAX_LENGTH}
            disabled={isEditMode}
            style={{ textTransform: "uppercase" }}
          />
        </Form.Item>

        <Form.Item name="note" label="角色备注">
          <TextArea
            placeholder="请输入角色备注（可选）"
            rows={4}
            maxLength={ROLE_NOTE_VALIDATION.MAX_LENGTH}
            showCount
          />
        </Form.Item>

        {isEditMode && (
          <Form.Item
            name="status"
            label="状态"
            rules={[{ required: true, message: "请选择角色状态" }]}
            valuePropName="checked"
            getValueFromEvent={(checked) =>
              checked ? RoleStatus.ACTIVE : RoleStatus.INACTIVE
            }
            getValueProps={(value) => ({
              checked: value === RoleStatus.ACTIVE,
            })}
          >
            <Switch
              checkedChildren={RoleStatusLabels[RoleStatus.ACTIVE]}
              unCheckedChildren={RoleStatusLabels[RoleStatus.INACTIVE]}
            />
          </Form.Item>
        )}
      </Form>
    </Modal>
  )
}

export default RoleModal
